export default __webpack_public_path__ + "static/media/icon_market_active.af684a3e.svg";